import { Component } from '@angular/core';

@Component({
  selector: 'app-tab-qa-nc',
  templateUrl: './tab-qa-nc.component.html',
  styleUrls: ['./tab-qa-nc.component.scss']
})
export class TabQaNcComponent {}
